import { Amplify } from 'aws-amplify'
import type { AppConfig } from './types/runtime-config'

export function configureAmplify(config: AppConfig) {
  const { region, userPoolId, userPoolClientId, apiBaseUrl } = config

  if (!region || !userPoolId || !userPoolClientId) {
    return
  }

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          email: true
        }
      }
    },
    API: {
      GraphQL: {
        endpoint: apiBaseUrl,
        region,
        defaultAuthMode: 'userPool'
      }
    }
  })
}
